<template>
  <div>
    <b-row>
      <b-col cols="12" md="3">
        <b-card-text v-if="resumes && ((typeof screening.connectionRequest.accepted !== 'undefined') && screening.connectionRequest.accepted !== false)">
          <span class="text-muted">Name:</span>
          <br />
          {{screening.candidate.fname}} {{screening.candidate.lname}}
        </b-card-text>
        <b-card-text v-else>
          <span class="text-muted">Candidate</span>
          <br />
          {{screening.candidate.userNum}}
        </b-card-text>
      </b-col>
      <b-col>
        <span class="text-muted">Candidate:</span>
        <br/>
        {{screening.candidate.UserNum}}
      </b-col>
      <b-col cols="2">
        <b-card-text>
          <span class="text-muted">Location</span>
          <br />
          {{screening.candidate.location}}
        </b-card-text>
      </b-col>
      <b-col cols="12" md="2">
        <b-card-text>
          <span class="text-muted">Skills Matched</span>
          <br />
          <b-badge variant="primary" pill>{{screening.candidate.skillsMatched}}</b-badge>
        </b-card-text>
      </b-col>
      <b-col cols="12" md="2">
        <b-btn
          pill
          variant="success"
          class="mr-3"
          @click="handleClick"
          v-if="!resumes && screening.status.submitted"
        >          
          View Answers
        </b-btn>
        <b-btn 
          v-if="screening.status.rejected"
          disabled
          pill
          variant="danger"
          class="mr-3"
        >
          Rejected
        </b-btn>
        <b-btn 
          v-if="!resumes && !screening.status.submitted && !screening.status.rejected"
          disabled
          pill
          variant="outline-primary"
          class="mr-3"
        >
          Awaiting response
        </b-btn>
        <b-btn 
          v-else-if="resumes && (typeof screening.connectionRequest.accepted !== 'undefined') && screening.connectionRequest.accepted !== false" 
          :href="screening.connectionRequest.accepted" 
          variant="success" 
          class="mr-3" 
          target="_BLANK"
          @click="processComplete"
        >
          Download Resumé
          <span v-if="screening.connectionRequest.downloadCount != 'undefined' && screening.connectionRequest.downloadCount > 0">
              (Downloads: {{screening.connectionRequest.downloadCount}})
          </span>
        </b-btn>
        <b-btn 
          v-else-if="resumes && !screening.connectionRequest.sent && screening.status.submitted"
          variant="primary" 
          class="mr-3"
          :disabled="screening.connectionRequest.sent === true && screening.connectionRequest.accepted === false && screening.connectionRequest.rejected === false"
          @click="requestResume"
        >
          Resumé Requested
        </b-btn>
      </b-col>
      <b-col cols="12" md="1">
        <b-icon-chevron-down font-scale="2"></b-icon-chevron-down>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-collapse :id="`screening${screening.uid}`" accordion="candidate-list" role="tabpanel">
          <b-row>
            <b-col cols="12">
              <b-card-body>
                <b-card-text class="font-weight-bold text-muted">More Details:</b-card-text>
              </b-card-body>
            </b-col>
            <b-col cols="12" md="6">
              <b-card-body>
                <b-card-text>
                  Skills:
                  <b-list-group v-if="screening.candidate">
                    <b-list-group-item v-for="(skill, j) in screening.candidate.skills" :key="j">
                      {{skill.name}}
                      <b-badge variant="success" pill v-if="skillMatched(skill)">matched</b-badge>
                    </b-list-group-item>
                  </b-list-group>
                </b-card-text>
              </b-card-body>
            </b-col>
            <b-col cols="12" md="6">
              <b-card-body>
                <span class="text-muted">Description:</span>
                <b-card-text v-html="screening.candidate.profileDesc"></b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-collapse>
      </b-col>
    </b-row>
    <b-modal
      v-model="show"
      size="lg"
      :title="`Questionaire - ${job.position}`"
      :hide-footer="screening.connectionRequest.accepted === false && (screening.status.rejected || !screening.status.submitted)"
    >
      <b-container class="pa-4 my-4" v-if="job.description" v-html="job.description">
      </b-container>
      <hr />
      <Questionaire v-bind:screening="screening"></Questionaire>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="muted"
            class="float-left text-danger"
            @click="rejectCandidate"
          >I'm not interested</b-button>
          <b-button v-if="(typeof screening.connectionRequest.accepted !== 'undefined') && screening.connectionRequest.accepted !== false" :href="screening.connectionRequest.accepted" variant="primary" class="float-right" target="_BLANK">Download Resumé</b-button>
          <b-button v-else variant="primary" class="float-right" @click="requestResume">Request Resumé</b-button>
          <b-button variant="muted" class="float-right mr-2" @click="show=false">Close</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>

import User from '@/fstore/collections/User';
import Screening from '@/fstore/collections/Screening';
import Questionaire from '@/components/questionaires/Questionaire'
import moment from 'moment';

export default {
    name: 'QuestionaireItem',
    components: {
        Questionaire
    },
    props: ['screening', 'job', 'resumes'],
    data () {
        return {
          show: false,
          candidate: User.getTemplate()
        }
    },
    methods: {
        skillMatched(candidateSkill) {
          const matched = this.job.skills.some(skill => skill.name == candidateSkill.name);
          return matched;
        },
        getDaysLeftUntilQuestionnaireExpires(expires) {
            expires = moment(expires.toDate());
            
            const today = moment();
            const daysLeft = expires.diff(today, 'days')+1;
            
            if(daysLeft >= 1) {
                return `Expires in ${daysLeft} day${daysLeft > 1? 's' : ''}`;
            }else if (daysLeft == 0) {
                return `Expires Today!`;
            }
        },
        handleClick() {
            this.screening.status.opened = true;
            this.show = true
        },
        async rejectCandidate(screening) {
          const confirmed = await this.$bvModal.msgBoxConfirm('Are you sure you\'re not interested in this candidate? You cannot undo this action.', {
            title: 'Are you sure?',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'I\'m not interested',
            cancelTitle: 'Cancel',
            cancelVariant: 'text',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          });

          if(confirmed) {
            try {
              this.$store.dispatch('app/setOverlay', true);
              this.screening.status.rejected = true;
              this.screening.rejection.companyAcknowledged = true;
              this.screening.rejection.rejected_date = new Date();
              this.screening.rejection.rejected_by = "company";
              this.screening.rejection.rejected_reason = "";

              await Screening.update(this.screening);

              await this.$store.dispatch('screening/fetchAll', {jobId: this.job.uid});

            } catch(err) {
              console.error(err);
            } 
            this.$store.dispatch('app/setOverlay', false);
            console.log("emitting updateCount");
            this.$emit("updateCount");
          }
        },
        async requestResume() {
          this.$store.dispatch('app/setOverlay', true);
          this.screening.connectionRequest.sent = true;
          await Screening.update(this.screening);
          await this.$store.dispatch('screening/fetchAll', {jobId: this.job.uid});
          this.$store.dispatch('app/setOverlay', false);
          this.show = false;

          this.$bvModal.msgBoxOk("You've sent a resumé request.");
        },
        async processComplete(){
          // increase the download count
          if (this.screening.connectionRequest == 'undefined'){
            this.screening.connectionRequest.downloadCount = 1;
          }else {
            this.screening.connectionRequest.downloadCount += 1;
          }

          await Screening.update(this.screening);
          this.$bvModal.msgBoxOk("Congrats! You've successfully completed the candidate workflow. Thank you for using career pilot.");
        }
    }
}
</script>